/** Deve coincidir com `legal.confirmation_phrase` no backend. */
export const TERMS_CONFIRMATION_PHRASE = 'Eu entendo, concordo e aceito os termos'

export const TERMS_SCROLL_TOLERANCE_PX = 8

import type { LegalDocumentStatusItem } from '@/types/legal-documents'

export interface TermsAcceptanceFields {
  terms_accepted_at?: string | null
  terms_version?: string | null
  terms_current_version?: string | null
  terms_acceptance_required?: boolean
  legal_documents_status?: LegalDocumentStatusItem[]
}

export function isScrollComplete(
  element: HTMLElement | null,
  tolerancePx: number = TERMS_SCROLL_TOLERANCE_PX
): boolean {
  if (!element) return false
  const { scrollTop, clientHeight, scrollHeight } = element
  if (scrollHeight <= clientHeight + tolerancePx) {
    return true
  }
  return scrollTop + clientHeight >= scrollHeight - tolerancePx
}

export function isConfirmationPhraseValid(
  input: string,
  expectedPhrase: string = TERMS_CONFIRMATION_PHRASE
): boolean {
  const expected = expectedPhrase.trim().toLowerCase()
  const provided = input.trim().toLowerCase()
  return expected.length > 0 && provided === expected
}

export function resolveTermsAcceptanceRequired(
  entity: TermsAcceptanceFields | null | undefined,
  options?: { failSafeWhenMissing?: boolean }
): boolean {
  if (!entity) {
    return options?.failSafeWhenMissing === true
  }

  const statuses = entity.legal_documents_status
  if (statuses && statuses.length > 0) {
    if (statuses.some((item) => item.acceptance_required)) {
      return true
    }
    if (entity.terms_acceptance_required === false) {
      return false
    }
  }

  if (entity.terms_acceptance_required === true) return true
  if (entity.terms_acceptance_required === false) return false

  if (!entity.terms_accepted_at) return true

  const acceptedVersion = entity.terms_version ?? null
  const currentVersion = entity.terms_current_version ?? null
  if (!currentVersion) {
    return true
  }

  return acceptedVersion !== currentVersion
}
